var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Private constants
const CASELOAD_FILTER_ID = 1;
const ALL_STUDENTS_FILTER_ID = 2;
export default class FilterService {
    /**
     * Async because we may want to load in this value from the server
     * instead of hard coding it.
     */
    static getCaseloadFilterId() {
        return __awaiter(this, void 0, void 0, function* () {
            return CASELOAD_FILTER_ID;
        });
    }
    /**
     * Async because we may want to load in this value from the server
     * instead of hard coding it.
     */
    static getAllStudentsFilterId() {
        return __awaiter(this, void 0, void 0, function* () {
            return ALL_STUDENTS_FILTER_ID;
        });
    }
}
